export const TICKET_STATUSES = {
    0: 'Open',
    1: 'Pending',
    2: 'Resolved',
    3: 'Closed',
    4: 'Waiting on Client',
    5: 'Waiting on Third Party',
    6: 'New',
    7: 'Waiting on Internal Contact'
};

export const TICKET_PRIORITIES = {
    0: 'Low',
    1: 'Medium',
    2: 'High',
    3: 'Urgent'
};

export const TICKET_PRIORITY_COLOURS = {
    0: '#1890ff',
    1: '#fee715ff',
    2: '#f1b44c',
    3: '#f46a6a'
};

export const TICKET_DIFFICULTIES = {
    1: '1 - Very Low',
    2: '2 - Low',
    3: '3 - Medium',
    4: '4 - High',
    5: '5 - Very High'
};

export const TICKET_SOURCES = {
    phone: 'Phone',
    emergency_phone: 'Emergency Phone',
    email: 'Email',
    urgent_email: 'urgent@',
    whatsapp: 'WhatsApp',
    other: 'Other'
};

export default {
    methods: {
        getHumanReadableTicketStatus(priority) {
            return TICKET_STATUSES[priority];
        },

        getTicketStatusCodeFromHumanReadable(statusString) {
            return Object.keys(TICKET_STATUSES)[Object.values(TICKET_STATUSES).indexOf(statusString)];
        },

        getHumanReadableTicketPriority(priority) {
            return TICKET_PRIORITIES[priority];
        },

        getTicketPriorityCodeFromHumanReadable(priorityString) {
            return Object.keys(TICKET_PRIORITIES)[Object.values(TICKET_PRIORITIES).indexOf(priorityString)];
        },

        getHumanReadableTicketDifficulty(difficulty) {
            return TICKET_DIFFICULTIES[difficulty];
        },

        getTicketDifficultyCodeFromHumanReadable(difficultyString) {
            return Object.keys(TICKET_DIFFICULTIES)[Object.values(TICKET_DIFFICULTIES).indexOf(difficultyString)];
        },

        getTicketRowClass(ticket) {
            return 'ticket-priority-' + ticket.priority;
        },

        getHumanReadableTicketSource(source) {
            return TICKET_SOURCES[source];
        },

        getPriorityColour(priority) {
            return TICKET_PRIORITY_COLOURS[priority];
        },

        getPriorityTextColour(priority) {
            if (priority === 1) {
                return '#101820ff';
            }
            return '#fff';
        }
    },

    computed: {
        ticketStatusDropdownOptions() {
            let options = [];
            _.forEach(TICKET_STATUSES, (status, key) => {
                options.push({
                    value: Number(key),
                    label: status
                })
            })
            return options;
        },

        ticketPriorityDropdownOptions() {
            let options = [];
            _.forEach(TICKET_PRIORITIES, (status, key) => {
                options.push({
                    value: Number(key),
                    label: status
                })
            })
            return options;
        },

        ticketDifficultyDropdownOptions() {
            let options = [];
            _.forEach(TICKET_DIFFICULTIES, (status, key) => {
                options.push({
                    value: Number(key),
                    label: status
                })
            })
            return options;
            // return [1, 2, 3, 4, 5];
        },

        ticketSourceDropdownOptions() {
            let options = [];
            _.forEach(TICKET_SOURCES, (source, key) => {
                options.push({
                    value: key,
                    label: source
                })
            })
            return options;
        },
    }
}
